import { CKSelect, CKTooltip } from 'clearkit';
import { ReactNode } from 'react';

import { ConditionalOverwriteSelectProps } from './types';
import {
  getConditionalOverwriteOptions,
  isSystemFieldMapping,
  toConditionalOverwriteItem,
} from './util';

export function ConditionalOverwriteSelect({
  integration,
  mapping,
  onChange,
}: ConditionalOverwriteSelectProps) {
  const isDisabled = integration === 'marketo' || isSystemFieldMapping(mapping);
  const value = isDisabled ? false : mapping.conditionalOverwrite;
  const conditionalOverwriteItem = toConditionalOverwriteItem(value);

  return (
    <div className="w-full">
      <WrapWithSystemTooltip integration={integration} showTooltip={isDisabled}>
        <CKSelect
          isDisabled={isDisabled}
          items={getConditionalOverwriteOptions()}
          onSelectedItemChange={({ selectedItem }) => {
            if (selectedItem?.value !== conditionalOverwriteItem.value) {
              onChange({
                conditionalOverwrite: selectedItem?.value === 'true',
              });
            }
          }}
          placeholder=""
          popoverPlacement="bottom-end"
          selectedItem={conditionalOverwriteItem}
        />
      </WrapWithSystemTooltip>
    </div>
  );
}

type WrapWithSystemTooltipProps = {
  integration: string;
  showTooltip: boolean;
  children: ReactNode;
};
function WrapWithSystemTooltip({
  integration,
  showTooltip,
  children,
}: WrapWithSystemTooltipProps) {
  if (!showTooltip) {
    return <>{children}</>;
  }

  return (
    <CKTooltip
      hasHover
      style={{
        display: 'block',
        width: '100%',
      }}
      tooltip={
        integration === 'marketo'
          ? 'This integration currently supports "Always overwrite" only'
          : 'Clearbit System Traits can only be set to "Always overwrite"'
      }
    >
      {children}
    </CKTooltip>
  );
}
